import API from "./lib/api";
import { voucherUrl } from "./lib/url";


export const getAllVoucherApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}${voucherUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addVoucherApi = async (voucherData) => {
    try {
        
        const response = await API.post( 
            `restaurant/vouchers`,
            voucherData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const editVoucherApi = async (voucherData, id) => {
    try {
        
        const { data } = await API.put( 
            `restaurant${voucherUrl}/${id}`,
            voucherData
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const getSingleVoucherApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `restaurant${voucherUrl}/${id}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const deleteVoucherApi = async (id) => {
    try {
        
        const response = await API.delete(`restaurant/vouchers/${id}`);
        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}